import { createExperimentHook } from '@prisjakt/ui-experiment';

export const usePriceListSmileyRatingExperiment = createExperimentHook(
  'price-list-smiley-rating',
  false,
  { show: true }
);

export const usePriceListExpandedPriceRowExperiment = createExperimentHook(
  'price-list-expanded-row-design',
  { show: false },
  { show: { show: true } }
);
